import z from "zod";
import { OrderStatus, OrderType } from "./order";
import { PaymentFormSchema } from "../payment";
import { PersonDeliveryFormSchema, PersonPickupFormSchema } from "../person";
import { AddressDeliveryAdminFormSchema } from "../address";
import { CourierSchema } from "../courier";
import { withOrderTimingValidation } from "./order";

export const PICKUP_MIN_ORDER_QUANTITY = 1;
export const DELIVERY_MIN_ORDER_QUANTITY = 2;

// Client schemas
const createOrderItemFormSchema = (
  minimumQuantity: number,
  minimumMessage: string,
) =>
  z.object({
    id: z.number().optional(), //im fucking lazy ok?
    quantity: z.coerce
      .number()
      .int({ message: "validation.order.quantity_integer" })
      .min(minimumQuantity, { message: minimumMessage }),
    product_item_name: z.string(),
  });

const PickupOrderItemFormSchema = createOrderItemFormSchema(
  PICKUP_MIN_ORDER_QUANTITY,
  "validation.order.quantity_min",
);

const DeliveryOrderItemFormSchema = createOrderItemFormSchema(
  DELIVERY_MIN_ORDER_QUANTITY,
  "validation.order.quantity_min_delivery",
);

const OrderFormBaseSchema = z.object({
  id: z.string().optional(), //im fucking lazy ok?
  preffered_time: z.string().nullish(),
  preffered_date: z.string().nullish(),
  status: z.nativeEnum(OrderStatus).optional(),
  payment: PaymentFormSchema,
  comment: z.string().optional(),
  asFastAsPossible: z.boolean().nullish(),
  recaptcha_token: z.string().nullish(),
});

export const OrderPickupFormSchema = OrderFormBaseSchema.extend({
  type: z.literal(OrderType.PICKUP),
  order_item: PickupOrderItemFormSchema,
  person: PersonPickupFormSchema,
});

export const OrderDeliveryFormSchema = OrderFormBaseSchema.extend({
  type: z.literal(OrderType.DELIVERY),
  order_item: DeliveryOrderItemFormSchema,
  person: PersonDeliveryFormSchema,
});

export const OrderFormSchema = withOrderTimingValidation(
  z.discriminatedUnion("type", [
    OrderPickupFormSchema,
    OrderDeliveryFormSchema,
  ]),
);
export type OrderPayload = z.infer<typeof OrderFormSchema>;

// Admin schemas
const OptionalEmailSchema = z
  .union([
    z.literal(""),
    z.string().email({ message: "validation.field.invalidEmail" }),
  ])
  .nullish();

export const PersonDeliveryAdminFormSchema = PersonDeliveryFormSchema.extend({
  first_name: z.string().nullish(),
  last_name: z.string().nullish(),
  email: OptionalEmailSchema,
  address: AddressDeliveryAdminFormSchema,
});

export const PersonPickupAdminFormSchema = PersonPickupFormSchema.extend({
  first_name: z.string().nullish(),
  last_name: z.string().nullish(),
  email: OptionalEmailSchema,
});

export const OrderPickupAdminFormSchema = OrderFormBaseSchema.extend({
  type: z.literal(OrderType.PICKUP),
  order_item: PickupOrderItemFormSchema,
  person: PersonPickupAdminFormSchema,
});

export const OrderDeliveryAdminFormSchema = OrderFormBaseSchema.extend({
  type: z.literal(OrderType.DELIVERY),
  order_item: DeliveryOrderItemFormSchema,
  person: PersonDeliveryAdminFormSchema,
  courier: CourierSchema.nullish(),
});

const OrderAdminFormBaseSchema = z.discriminatedUnion("type", [
  OrderPickupAdminFormSchema,
  OrderDeliveryAdminFormSchema,
]);

export const OrderAdminFormSchema = withOrderTimingValidation(
  OrderAdminFormBaseSchema,
  false,
);

export type OrderAdminPayload = z.infer<typeof OrderAdminFormSchema>;
